import i18next from 'i18next';

import ptbr from './pt-br.json';

export default function i18nextInit(): void {
  i18next.init({
    resources: {
      'pt-BR': {
        translation: ptbr,
      },
    },
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
  });
}
